module.exports = __webpack_public_path__ + "img/xjpn.df34f91e.jpg";